"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Footer", {
    enumerable: true,
    get: function() {
        return Footer;
    }
});
var _react = _interop_require_default(require("react"));
var _components = require("@cmpsr/components");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Footer = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        maxWidth: "66.75rem",
        flexDirection: "column",
        width: "100%"
    }, props));
};
var FooterLogo = function(props) {
    return _react.default.createElement(_components.Image, _object_spread({
        alt: "Footer image",
        width: "100%",
        mb: {
            base: "2.75rem",
            md: "3rem"
        }
    }, props));
};
var FooterContent = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        flexDirection: {
            base: "column",
            lg: "row"
        },
        gap: {
            base: "2.75rem",
            md: "3rem"
        }
    }, props));
};
var FooterBottom = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_components.Divider, _object_spread({
        width: "100%",
        my: {
            base: "2.75rem",
            md: "4rem"
        }
    }, props)), children);
};
var FooterActionsContainer = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        gap: {
            base: "2.75rem",
            lg: "1.5rem"
        },
        flexDirection: {
            base: "column",
            md: "row"
        },
        flex: {
            lg: 1
        }
    }, props));
};
var FooterActions = function(_param) {
    var children = _param.children, title = _param.title, props = _object_without_properties(_param, [
        "children",
        "title"
    ]);
    return _react.default.createElement(_components.Flex, _object_spread({
        flexDirection: "column",
        gap: "0.75rem",
        flex: 1
    }, props), title && _react.default.createElement(_components.Text, {
        variant: "text-body-bold",
        mb: "0.5rem"
    }, title), children);
};
var FooterAction = function(props) {
    return _react.default.createElement(_components.Link, _object_spread({
        size: "m",
        variant: "link-secondary"
    }, props));
};
Footer.Logo = FooterLogo;
Footer.ActionsContainer = FooterActionsContainer;
Footer.Actions = FooterActions;
Footer.Action = FooterAction;
Footer.Bottom = FooterBottom;
Footer.CopyGroup = _components.Flex;
Footer.Content = FooterContent;
